module.exports = __webpack_public_path__ + "img/sulphites.eb6730a7.png";